import cn from 'classnames'
import moment from 'moment'
import Image from 'next/image'
import React from 'react'
import { IEvent } from 'src/graphql/generated/hooks'
import { useDefaultLogo } from 'src/hooks/useDefaultLogo'

interface EventDetailHeaderProps {
  className?: string
  event: IEvent
}

/**
 * Primary UI component for user interaction
 */
export const EventDetailHeader: React.FC<EventDetailHeaderProps> = ({ className, event }) => {
  const formatedDate = moment(event?.date).format('ddd, MMMM DD, YYYY')
  const logo = useDefaultLogo(event?.logo?.url)
  const location = [event?.city, event?.country].filter((str) => !!str).join(', ')
  const format = event?.formatId?.name

  return (
    <div className={cn(className, 'flex flex-row justify-center bg-clouds')}>
      <div className="flex flex-row w-full justify-center">
        <div className="flex flex-row md:pl-0 px-5 !max-w-[1100px] w-full py-2">
          <div className="flex flex-col md:flex-row sm:grid-cols-2">
            <Image
              className="h-[120px] w-[120px] rounded-[8px] bg-desertStorm object-contain shadow-[0_0_10px_0_rgba(0, 0, 0, 0.1)] mx-auto mt-[20px] mb-[13px] md:mr-[1.25rem] md:mt-[1.85rem] md:mb-[2.5625rem]"
              alt="logo"
              src={logo}
              priority
              width={120}
              height={120}
            />
            <div className="flex items-center">
              <div className="flex flex-row">
                <div className="flex flex-col">
                  <div className="flex flex-col">
                    <h1 className="pt-[0.1rem] pb-[0.125rem] font-bold font-secondary text-[#222222] text-[24px] text-center md:text-left md:text-[1.875rem]">
                      {event?.title || ''}
                    </h1>
                    <div className="flex md:flex-row flex-col">
                      <h2 className="pt-[0.5rem] pb-[0.625rem] font-primary text-darkgray md:text-[18px] text-[14px]">
                        {formatedDate} •
                      </h2>
                      <h2 className="pt-[0.5rem] pb-[0.625rem] font-primary text-darkgray md:text-[18px] text-[14px] md:ml-[24px]">
                        {location}
                        {format && <i>(&nbsp;{format}&nbsp;)</i>}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
